<template>
  <div>
    <div class="flex flex-row items-center gap-1">
      <template
        v-for="(key, index) in keyCombinationKeys"
        :key="key"
      >
        <KeyboardKey>
          {{ key }}
        </KeyboardKey>
        <span
          v-if="index < keyCombinationKeys.length - 1"
          class="text-base-300"
        >
          +
        </span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  /**
   * Format (example) "Ctrl+Shift+Key" for string or ["Ctrl", "Shift", "Key"] for array
   **/
  keyCombinbation: string[] | string;
}>();

const { keyCombinbation } = toRefs(props);

const keys = useMagicKeys();
const keyComboActive = computed(() => {
  if (Array.isArray(keyCombinbation.value)) {
    return keys[keyCombinbation.value.join("+")].value;
  }

  return keys[keyCombinbation.value].value;
});

const keyCombinationKeys = computed(() => {
  if (Array.isArray(keyCombinbation.value)) {
    return keyCombinbation.value;
  }

  return keyCombinbation.value.split("+");
});
</script>

<style scoped></style>
